import { createFileRoute } from "@tanstack/react-router";

import { CreatePostDialog, PostFeed } from "@/components/posts";
import { useGroupRouteData } from "@/hooks/use-group-route-data";

export const Route = createFileRoute("/_authenticated/app/groups/$groupId/posts")({
  component: GroupPostsTab,
});

function GroupPostsTab() {
  const { groupId, currentUser, isAdmin, canPost } = useGroupRouteData(Route.useParams().groupId);

  return (
    <div className="mx-auto max-w-180 space-y-6">
      {canPost && (
        <div className="flex justify-end">
          <CreatePostDialog groupId={groupId} />
        </div>
      )}
      <PostFeed
        groupId={groupId}
        currentUserId={currentUser?._id}
        isAdmin={isAdmin}
        canPost={canPost}
      />
    </div>
  );
}
